module.exports = __webpack_public_path__ + "assets/img/47f50bb42015d68383989db187a8f608.svg";